import { Component } from '@angular/core'
import {
  MbMyaccountAddressbookBaseComponent
} from '../mb-myaccount-addressbook-base/mb-myaccount-addressbook-base.component'
import {
  MbMyaccountAddressbookConnector
} from '../../../connectors/mb-myaccount-addressbook.connector'
import { MbCheckoutRegions } from '../../../../models'

@Component({
  selector: 'mb-myaccount-addressbook-au',
  templateUrl: './mb-myaccount-addressbook-au.component.html',
  styleUrls: ['../mb-myaccount-addressbook-base/mb-myaccount-addressbook-base.component.scss']
})
export class MbMyaccountAddressbookAuComponent extends MbMyaccountAddressbookBaseComponent {

  checkoutRegion = MbCheckoutRegions.AU

  constructor (protected mbMyaccountAddressbookConnector: MbMyaccountAddressbookConnector) {
    super(mbMyaccountAddressbookConnector)
  }
}
